/* ===================================================================
   STAR — thème Shopify
   Panier tiroir · sélection de variante · galerie · mega-menu
   Remplace l'ancien js/app.js (le checkout est désormais géré par Shopify).
=================================================================== */
(function () {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S  = window.STAR || {};
  const T  = S.strings || {};

  const money = cents =>
    new Intl.NumberFormat(S.locale || 'fr', {
      style: 'currency',
      currency: S.currency || 'EUR'
    }).format((cents || 0) / 100);

  /* ---------- TOAST ---------- */
  function toast(msg) {
    const wrap = $('#toastWrap');
    if (!wrap) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = msg;
    wrap.appendChild(el);
    setTimeout(() => el.classList.add('show'), 10);
    setTimeout(() => { el.classList.remove('show'); setTimeout(() => el.remove(), 300); }, 2600);
  }

  /* ===================================================================
     PANIER (tiroir) — /cart.js, /cart/add.js, /cart/change.js
  =================================================================== */
  const drawer  = $('#cartDrawer');
  const overlay = $('#drawerOverlay');

  const openDrawer  = () => { drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); };
  const closeDrawer = () => { drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); };

  async function fetchCart() {
    const res = await fetch(S.routes.cart);
    return res.json();
  }

  function lineItemHTML(item) {
    const props = Object.entries(item.properties || {})
      .filter(([k, v]) => v && !k.startsWith('_'))
      .map(([k, v]) => `<br>${k} : <strong>${v}</strong>`)
      .join('');

    const img = item.image
      ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2')}" alt="">`
      : '';

    return `<div class="line-item">
      <a class="li-media" href="${item.url}">${img}</a>
      <div class="li-info">
        <div class="li-name">${item.product_title}</div>
        <div class="li-meta">${item.variant_title || ''}${props}</div>
        <div class="li-bottom">
          <div class="li-qty">
            <button type="button" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div>
          <span class="li-price">${money(item.final_line_price)}</span>
          <button type="button" class="li-remove" data-key="${item.key}" data-qty="0" aria-label="×">×</button>
        </div>
      </div>
    </div>`;
  }

  function renderDrawer(cart) {
    const count = $('#cartCount');
    if (count) {
      count.textContent = cart.item_count;
      count.style.display = cart.item_count ? 'flex' : 'none';
    }

    if (!cart.item_count) {
      drawer.innerHTML = `
        <div class="drawer-head">
          <h3>${T.cartTitle}</h3>
          <button class="drawer-close" id="drawerClose">×</button>
        </div>
        <div class="cart-empty">
          <h4>${T.cartEmpty}</h4>
          <button class="btn btn-dark" id="drawerKeep">${T.keepShopping}</button>
        </div>`;
      bindDrawer();
      return;
    }

    drawer.innerHTML = `
      <div class="drawer-head">
        <h3>${T.cartTitle}</h3>
        <button class="drawer-close" id="drawerClose">×</button>
      </div>
      <div class="drawer-body">${cart.items.map(lineItemHTML).join('')}</div>
      <div class="drawer-foot">
        <div class="drawer-total grand">
          <span>${T.subtotal}</span>
          <span>${money(cart.total_price)}</span>
        </div>
        <p class="ship-note">${T.shipNote}</p>
        <form action="${S.routes.cart_page}" method="post">
          <button type="submit" name="checkout" class="btn btn-dark btn-lg btn-block">${T.checkout}</button>
        </form>
      </div>`;
    bindDrawer();
  }

  function bindDrawer() {
    const close = $('#drawerClose');
    if (close) close.onclick = closeDrawer;
    const keep = $('#drawerKeep');
    if (keep) keep.onclick = closeDrawer;

    $$('[data-key]', drawer).forEach(btn => {
      btn.onclick = async () => {
        const cart = await changeQty(btn.dataset.key, +btn.dataset.qty);
        renderDrawer(cart);
      };
    });
  }

  async function changeQty(key, quantity) {
    const res = await fetch(S.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  const cartBtn = $('#cartBtn');
  if (cartBtn) {
    cartBtn.onclick = async () => {
      openDrawer();
      renderDrawer(await fetchCart());
    };
  }
  if (overlay) overlay.onclick = closeDrawer;
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* Page panier : les +/−/× utilisent la même API */
  $$('.line-item [data-key]').forEach(btn => {
    btn.onclick = async () => {
      await changeQty(btn.dataset.key, +btn.dataset.qty);
      location.reload();
    };
  });

  /* ===================================================================
     FICHE PRODUIT
  =================================================================== */
  const pdp = $('#pdp');
  if (pdp) {
    const variants = JSON.parse($('#variantData').textContent);
    const form     = $('#productForm');
    const idInput  = $('#variantId');
    const addBtn   = $('#addBtn');
    const priceBox = $('#pdpPrice');

    /* La sélection courante, option par option (index 0 = Genre, 1 = Taille) */
    const selected = [];
    $$('.opt-row').forEach(row => {
      const i = +row.dataset.optionIndex;
      const on = $('.opt.on', row);
      selected[i] = on ? on.dataset.value : null;
    });

    function matchVariant() {
      return variants.find(v =>
        selected.every((val, i) => val === null || v.options[i] === val)
      );
    }

    function refresh() {
      const v = matchVariant();
      const complete = selected.every(x => x !== null);

      if (!complete) {
        addBtn.disabled = false;             // on laisse cliquer → message « choisis une taille »
        addBtn.textContent = T.chooseSize;
        return;
      }
      if (!v) { addBtn.disabled = true; addBtn.textContent = T.soldOut; return; }

      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.label : T.soldOut;

      if (priceBox) {
        let html = `<span class="now">${money(v.price)}</span>`;
        if (v.compare_at_price > v.price) {
          const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          html += `<span class="old">${money(v.compare_at_price)}</span><span class="save">-${pct}%</span>`;
        }
        priceBox.innerHTML = html;
      }

      /* URL propre (partage / retour arrière) */
      const url = new URL(location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    /* Mémorise le libellé d'origine du bouton */
    if (addBtn) addBtn.dataset.label = addBtn.textContent.trim();

    $$('.opt-row .opt').forEach(opt => {
      opt.onclick = () => {
        const row = opt.closest('.opt-row');
        const i = +row.dataset.optionIndex;
        $$('.opt', row).forEach(o => o.classList.remove('on'));
        opt.classList.add('on');
        selected[i] = opt.dataset.value;
        refresh();
      };
    });
    refresh();

    /* Ajout au panier en AJAX (garde le tiroir, pas de rechargement) */
    if (form) {
      form.addEventListener('submit', async e => {
        e.preventDefault();

        if (selected.some(x => x === null)) {
          toast(T.chooseSize);
          const row = $$('.opt-row').find((r, i) => selected[i] === null);
          if (row) row.animate(
            [{ transform: 'translateX(-5px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }],
            { duration: 220 }
          );
          return;
        }

        const res = await fetch(S.routes.cart_add, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: +idInput.value,
              quantity: +$('#qVal').value,
              properties: collectProperties()
            }]
          })
        });

        if (!res.ok) {
          const err = await res.json();
          toast(err.description || err.message || 'Erreur');
          return;
        }

        toast(T.added);
        openDrawer();
        renderDrawer(await fetchCart());
      });
    }

    function collectProperties() {
      const props = {};
      $$('[name^="properties["]', form).forEach(input => {
        const key = input.name.match(/properties\[(.+)\]/)[1];
        if (input.value.trim() !== '') props[key] = input.value.trim();
      });
      return props;
    }

    /* Quantité */
    const qVal = $('#qVal');
    $('#qMinus').onclick = () => { qVal.value = Math.max(1, +qVal.value - 1); };
    $('#qPlus').onclick  = () => { qVal.value = +qVal.value + 1; };

    /* Galerie */
    $$('.thumb').forEach(btn => {
      btn.onclick = () => {
        const i = btn.dataset.mi;
        $$('.thumb').forEach(b => b.classList.remove('on'));
        btn.classList.add('on');
        $$('.gal-slide').forEach(s => s.classList.toggle('hidden', s.dataset.mi !== i));
      };
    });

    /* Bouton « Personnaliser » → descend vers les champs nom/numéro */
    const perso = $('#persoBtn');
    if (perso) perso.onclick = () => {
      $('#custBlock').scrollIntoView({ behavior: 'smooth', block: 'center' });
      $('#custName').focus();
    };

    /* Accordéon */
    $$('.acc-head').forEach(h => {
      h.onclick = () => {
        const item = h.parentElement;
        item.classList.toggle('open');
        $('.pm', h).textContent = item.classList.contains('open') ? '−' : '+';
      };
    });
  }

  /* ===================================================================
     MEGA-MENU + LANGUES + BURGER
  =================================================================== */
  let megaTimer;
  const hideMega = () => {
    megaTimer = setTimeout(() => $$('.mega').forEach(m => m.classList.remove('open')), 160);
  };

  $$('#mainNav a[data-menu]').forEach(a => {
    a.onmouseenter = () => {
      if (window.innerWidth <= 820) return;
      clearTimeout(megaTimer);
      $$('.mega').forEach(m => m.classList.remove('open'));
      const mega = $('#mega-' + a.dataset.menu);
      if (mega) mega.classList.add('open');
    };
  });
  $$('#mainNav a:not([data-menu])').forEach(a => { a.onmouseenter = hideMega; });
  $$('.mega').forEach(m => {
    m.onmouseenter = () => clearTimeout(megaTimer);
    m.onmouseleave = hideMega;
  });
  const header = $('#header');
  if (header) header.onmouseleave = hideMega;

  const langBtn = $('#langBtn');
  if (langBtn) {
    langBtn.onclick = e => {
      e.stopPropagation();
      const menu = $('#langMenu');
      menu.hidden = !menu.hidden;
    };
    document.addEventListener('click', () => {
      const menu = $('#langMenu');
      if (menu) menu.hidden = true;
    });
  }

  const burger = $('#burger');
  if (burger) burger.onclick = () => $('#mainNav').classList.toggle('open');
})();
